import { Button } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { estApiError } from '../../api/errors.js';
import { PresentationExpiree } from './horsLigne/magasin.js';
import styles from './Presentation.module.css';

export function ErreurPresentation({
  erreur,
  recharger,
}: {
  erreur: unknown;
  recharger?: () => void;
}) {
  const { t } = useTranslation('presentation');
  if (!erreur) return null;
  const conflit = estApiError(erreur) && erreur.status === 409;
  let message = conflit ? 'conflit' : 'erreur';
  if (erreur instanceof PresentationExpiree) message = 'horsLigne.expiree';
  return (
    <div role="alert" className={styles.erreur}>
      <p>{t(message)}</p>
      {recharger ? (
        <Button variant="secondary" onClick={recharger}>
          {t('recharger')}
        </Button>
      ) : null}
    </div>
  );
}
